"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.reset = exports.removeMessage = exports.setMessage = exports.attachFile = exports.deleteMessage = exports.sendMessage = exports.getChatMessages = exports.getChatList = exports.resetFilter = exports.resetChat = exports.resetState = exports.chatListError = exports.updateChatList = exports.removeInvalidFile = exports.removeAttachmentFromView = exports.deleteMessageFromList = exports.updateFilesList = exports.updateMediaList = exports.updateMessageList = exports.setMessageList = exports.deSelectChat = exports.selectChat = exports.filterChatList = exports.chatList = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const api_1 = require("../../services/api");
const moment_1 = __importDefault(require("moment"));
const preloaderSlice_1 = require("./preloaderSlice");
const store_1 = __importDefault(require("../store"));
const common_1 = require("../../utils/common");
const generatePreview = (preview) => {
    return {
        body: {
            message: "",
            attachments: [{
                    preview: preview.preview,
                    type: preview.type,
                    name: preview.name
                }]
        },
        from: preview.user,
        createdAt: moment_1.default().toString(),
        id: Date.now(),
        previewIndex: preview.index,
        isInvalid: !preview.isValid,
    };
};
const initialState = {
    list: [],
    activeChatCaseId: null,
    activeChatId: null,
    activeChat: null,
    lastActiveChat: null,
    messages: [],
    media: [],
    files: [],
    filter: {
        offset: 0,
        limit: 25,
        pattern: '',
        action: 'chat'
    }
};
const chatSlice = toolkit_1.createSlice({
    name: 'chat',
    initialState: initialState,
    reducers: {
        chatList: (state, action) => {
            const user = api_1.Auth.getStorageUser();
            //list.sort((a: any, b: any) => b.createdAt - a.createdAt);
            state.list = action.payload.map((el) => {
                if (el.from.id === user.id) {
                    el.sender = el.to;
                }
                else if (el.to.id === user.id) {
                    el.sender = el.from;
                }
                el.isActive = true;
                //el.createdAt = new Date(el.createdAt);
                return el;
            });
            state.lastActiveChat = null;
            return state;
        },
        updateChatList: (state, action) => {
            const { payload } = action;
            const chatIndex = state.list.findIndex((l) => {
                return (l.case_id == payload.case) ||
                    (l.fatt_id && l.fatt_id == payload.fatt_id) ||
                    (l.rc_id && l.rc_id == payload.rc_id) ||
                    (l.cr_id && l.cr_id == payload.cr_id) ||
                    (l.tr_id && l.tr_id == payload.tr_id);
            });
            if (chatIndex > -1) {
                const chat = state.list[chatIndex];
                chat.body = typeof payload.body === 'string' ? payload.body : JSON.stringify(payload.body);
                if (chatIndex > 0) {
                    state.list.splice(chatIndex, 1);
                    state.list.unshift(chat);
                }
                else {
                    state.list[chatIndex] = chat;
                }
            }
            return state;
        },
        filterChatList: (state, action) => {
            const pattern = action.payload.pattern.toLowerCase();
            state.list.forEach((el) => {
                let matchedData = el.sender.name.toLowerCase().includes(pattern), matchedCaseType = false, matchedCaseName = false;
                if (el.case.casename) {
                    matchedCaseName = el.case.casename.toLowerCase().includes(pattern);
                }
                if (el.case.casetype) {
                    matchedCaseType = el.case.casetype.toLowerCase().includes(pattern);
                }
                el.isActive = matchedData || matchedCaseName || matchedCaseType;
            });
            state.filter = action.payload;
            return state;
        },
        selectChat: (state, action) => {
            state.activeChat = action.payload;
            return state;
        },
        deSelectChat: (state, action) => {
            state.activeChat = null;
            return state;
        },
        setMessageList: (state, action) => {
            state.messages = action.payload.messages.map((m) => {
                Object.assign(m, {
                    created: moment_1.default(m.createdAt).format('MMM DD')
                });
                return m;
            });
            state.media = action.payload.media;
            state.files = action.payload.files;
            return state;
        },
        updateMessageList: (state, action) => {
            const msg = Object.assign({}, action.payload);
            if (typeof msg.body === 'string') {
                msg.body = JSON.parse(msg.body);
            }
            Object.assign(msg, {
                created: moment_1.default(msg.createdAt).format('MMM DD')
            });
            if (msg.replacePreview) {
                const index = state.messages.findIndex(m => m.previewIndex === msg.replacePreview);
                if (index > -1) {
                    delete msg.replacePreview;
                    state.messages.splice(index, 1);
                }
            }
            state.messages.push(msg);
            return state;
        },
        updateMediaList: (state, action) => {
            state.media.unshift(action.payload);
            return state;
        },
        updateFilesList: (state, action) => {
            state.files.unshift(action.payload);
            return state;
        },
        deleteMessageFromList: (state, action) => {
            const msg = action.payload, messageIndex = state.messages.findIndex(i => i.id === msg.id);
            if (messageIndex > -1) {
                state.messages.splice(messageIndex, 1);
            }
            return state;
        },
        removeAttachmentFromView: (state, action) => {
            const msg = action.payload;
            typeof msg.body === 'string' ? msg.body = JSON.parse(msg.body) : null;
            if (msg.body && msg.body.attachments) {
                if (common_1.isImage(msg.body.attachments[0].type)) {
                    state.media = state.media.filter((obj) => obj.url !== msg.body.attachments[0].url);
                }
                else {
                    state.files = state.files.filter((obj) => obj.url !== msg.body.attachments[0].url);
                }
                return state;
            }
        },
        removeInvalidFile: (state) => {
            state.messages = state.messages.filter(obj => obj.isInvalid !== true);
            return state;
        },
        chatListError: (state, action) => action.payload,
        resetState: (state) => {
            state = initialState;
            return state;
        },
        resetChat: (state, action) => {
            state.messages = [];
            state.media = [];
            state.files = [];
            if (action.payload) {
                state.lastActiveChat = action.payload;
            }
            else {
                state.lastActiveChat = null;
            }
            state.activeChat = null;
            return state;
        },
        resetFilter: (state) => {
            state.filter = initialState.filter;
            return state;
        }
    }
});
_a = chatSlice.actions, exports.chatList = _a.chatList, exports.filterChatList = _a.filterChatList, exports.selectChat = _a.selectChat, exports.deSelectChat = _a.deSelectChat, exports.setMessageList = _a.setMessageList, exports.updateMessageList = _a.updateMessageList, exports.updateMediaList = _a.updateMediaList, exports.updateFilesList = _a.updateFilesList, exports.deleteMessageFromList = _a.deleteMessageFromList, exports.removeAttachmentFromView = _a.removeAttachmentFromView, exports.removeInvalidFile = _a.removeInvalidFile, exports.updateChatList = _a.updateChatList, exports.chatListError = _a.chatListError, exports.resetState = _a.resetState, exports.resetChat = _a.resetChat, exports.resetFilter = _a.resetFilter;
const getChatList = () => async (dispatch) => {
    try {
        dispatch(preloaderSlice_1.showLoader());
        const lastActiveChat = store_1.default.getState().chat.lastActiveChat;
        if (lastActiveChat) {
            await api_1.Chat.markAsRead({ caseId: lastActiveChat });
        }
        const payload = await api_1.Chat.list();
        const id = window.location.hash.split('=')[1];
        const chat = payload.find(p => p.case && p.case.id.toString() === id);
        if (chat) {
            const user = api_1.Auth.getStorageUser();
            if (chat.from.id === user.id) {
                chat.sender = chat.to;
            }
            else if (chat.to.id === user.id) {
                chat.sender = chat.from;
            }
            return dispatch(exports.selectChat(chat));
        }
        window.AppearMe.Widgets.Events.emit('onChatLists', payload);
        dispatch(exports.chatList(payload));
        dispatch(preloaderSlice_1.hideLoader());
    }
    catch (e) {
        dispatch(exports.chatListError(e));
        dispatch(preloaderSlice_1.hideLoader());
    }
};
exports.getChatList = getChatList;
const getChatMessages = (id) => async (dispatch) => {
    try {
        dispatch(preloaderSlice_1.showLoader());
        const payload = await api_1.Chat.getMessages(id);
        dispatch(exports.setMessageList(payload));
        await api_1.Chat.markAsRead({ caseId: id });
        dispatch(preloaderSlice_1.hideLoader());
    }
    catch (e) {
        dispatch(exports.chatListError(e));
        dispatch(preloaderSlice_1.hideLoader());
    }
};
exports.getChatMessages = getChatMessages;
const sendMessage = (msg) => async (dispatch) => {
    try {
        const payload = await api_1.Chat.postMessage(msg);
        dispatch(exports.updateMessageList(payload));
    }
    catch (e) {
        dispatch(exports.chatListError(e));
    }
};
exports.sendMessage = sendMessage;
const deleteMessage = (msg) => async (dispatch) => {
    const payload = await api_1.Chat.deleteMessage(msg.id);
    dispatch(exports.deleteMessageFromList(payload));
    dispatch(exports.removeAttachmentFromView(payload));
};
exports.deleteMessage = deleteMessage;
const attachFile = (data, preview) => async (dispatch) => {
    try {
        dispatch(exports.removeInvalidFile());
        const previewMessage = generatePreview(preview);
        dispatch(exports.updateMessageList(previewMessage));
        if (preview.isValid) {
            const payload = await api_1.Chat.attachFile(data);
            dispatch(exports.updateMessageList(Object.assign(Object.assign({}, payload.data), { replacePreview: preview.index })));
            if (common_1.isImage(payload.data.body.attachments[0].type)) {
                dispatch(exports.updateMediaList(payload.data.body.attachments[0]));
            }
            else {
                dispatch(exports.updateFilesList(payload.data.body.attachments[0]));
            }
        }
    }
    catch (e) {
        dispatch(exports.chatListError(e));
    }
};
exports.attachFile = attachFile;
const setMessage = (msg) => dispatch => {
    dispatch(exports.updateChatList(msg));
    typeof msg.body === 'string' ? msg.body = JSON.parse(msg.body) : null;
    if (store_1.default.getState().chat.activeChat) {
        dispatch(exports.updateMessageList(msg));
        if (msg.body.attachments) {
            if (common_1.isImage(msg.body.attachments[0].type)) {
                dispatch(exports.updateMediaList(msg.body.attachments[0]));
            }
            else {
                dispatch(exports.updateFilesList(msg.body.attachments[0]));
            }
        }
    }
};
exports.setMessage = setMessage;
const removeMessage = (msg) => dispatch => {
    dispatch(exports.deleteMessageFromList(msg));
    dispatch(exports.removeAttachmentFromView(msg));
};
exports.removeMessage = removeMessage;
const reset = id => async (dispatch) => {
    dispatch(exports.resetChat(id));
};
exports.reset = reset;
exports.default = chatSlice.reducer;
